import React, {useState} from 'react';
import FormButton from 'src/components/button';

interface Props {
  // section identifier string used for tracking
  section: string;
}

const WasThisHelpfulButtons = ({section}: Props) => {
  const yesButton = `gpa-modal-${section}-helpful-yes`;
  const noButton = `gpa-modal-${section}-helpful-no`;
  const [yesSelected, setYesSelected] = useState(window.localStorage.getItem(yesButton) === 'true');
  const [noSelected, setNoSelected] = useState(window.localStorage.getItem(noButton) === 'true');

  return (
    <div className="shared-gpa-modal-helpful-container">
      Was this helpful?
      <FormButton
        outline={!yesSelected}
        size="small"
        horizontalMargin
        buttonName={yesButton}
        onClick={() => {
          window.localStorage.setItem(yesButton, 'true');
          window.localStorage.setItem(noButton, 'false');
          setYesSelected(true);
          setNoSelected(false);
        }}
      >
        Yes
      </FormButton>
      <FormButton
        outline={!noSelected}
        size="small"
        buttonName={noButton}
        onClick={() => {
          window.localStorage.setItem(noButton, 'true');
          window.localStorage.setItem(yesButton, 'false');
          setNoSelected(true);
          setYesSelected(false);
        }}
      >
        No
      </FormButton>
    </div>
  );
};

export default WasThisHelpfulButtons;
